/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as Sign_inRouteImport } from './routes/sign_in'
import { Route as Sign_outRouteImport } from './routes/sign_out'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminOcr_datasetsRouteImport } from './routes/admin/ocr_datasets'
import { Route as AdminPlansRouteImport } from './routes/admin/plans'
import { Route as TTenant_idRouteRouteImport } from './routes/t/$tenant_id/route'
import { Route as AdminTenantsIndexRouteImport } from './routes/admin/tenants/index'
import { Route as AdminTenantsIdRouteImport } from './routes/admin/tenants/$id'
import { Route as TTenant_idIndexRouteImport } from './routes/t/$tenant_id/index'
import { Route as TTenant_idAi_chatRouteImport } from './routes/t/$tenant_id/ai_chat'
import { Route as TTenant_idSettingRouteImport } from './routes/t/$tenant_id/setting'
import { Route as TTenant_idTerms_of_useRouteImport } from './routes/t/$tenant_id/terms_of_use'
import { Route as TTenant_idUploadRouteImport } from './routes/t/$tenant_id/upload'
import { Route as TTenant_idUpload_historyRouteImport } from './routes/t/$tenant_id/upload_history'
import { Route as TTenant_idUsersRouteImport } from './routes/t/$tenant_id/users'
import { Route as TTenant_idMillsheetsUploadRouteImport } from './routes/t/$tenant_id/millsheets/upload'
import { Route as TTenant_idOrder_matchingIndexRouteImport } from './routes/t/$tenant_id/order_matching/index'
import { Route as TTenant_idOrder_matchingSteel_order_idRouteImport } from './routes/t/$tenant_id/order_matching/$steel_order_id'
import { Route as TTenant_idPlanCompleteRouteImport } from './routes/t/$tenant_id/plan/complete'
import { Route as TTenant_idPlanConfirmRouteImport } from './routes/t/$tenant_id/plan/confirm'
import { Route as TTenant_idShearing_certificatesIndexRouteImport } from './routes/t/$tenant_id/shearing_certificates/index'
import { Route as TTenant_idShearing_certificatesUploadRouteImport } from './routes/t/$tenant_id/shearing_certificates/upload'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_inRoute = Sign_inRouteImport.update({
  id: '/sign_in',
  path: '/sign_in',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_outRoute = Sign_outRouteImport.update({
  id: '/sign_out',
  path: '/sign_out',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminOcr_datasetsRoute = AdminOcr_datasetsRouteImport.update({
  id: '/ocr_datasets',
  path: '/ocr_datasets',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TTenant_idRouteRoute = TTenant_idRouteRouteImport.update({
  id: '/t/$tenant_id',
  path: '/t/$tenant_id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsIndexRoute = AdminTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTenantsIdRoute = AdminTenantsIdRouteImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TTenant_idIndexRoute = TTenant_idIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idAi_chatRoute = TTenant_idAi_chatRouteImport.update({
  id: '/ai_chat',
  path: '/ai_chat',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idSettingRoute = TTenant_idSettingRouteImport.update({
  id: '/setting',
  path: '/setting',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idTerms_of_useRoute = TTenant_idTerms_of_useRouteImport.update({
  id: '/terms_of_use',
  path: '/terms_of_use',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idUploadRoute = TTenant_idUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idUpload_historyRoute =
  TTenant_idUpload_historyRouteImport.update({
    id: '/upload_history',
    path: '/upload_history',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)
const TTenant_idUsersRoute = TTenant_idUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idMillsheetsUploadRoute =
  TTenant_idMillsheetsUploadRouteImport.update({
    id: '/millsheets/upload',
    path: '/millsheets/upload',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)
const TTenant_idOrder_matchingIndexRoute =
  TTenant_idOrder_matchingIndexRouteImport.update({
    id: '/order_matching/',
    path: '/order_matching/',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)
const TTenant_idOrder_matchingSteel_order_idRoute =
  TTenant_idOrder_matchingSteel_order_idRouteImport.update({
    id: '/order_matching/$steel_order_id',
    path: '/order_matching/$steel_order_id',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)
const TTenant_idPlanCompleteRoute = TTenant_idPlanCompleteRouteImport.update({
  id: '/plan/complete',
  path: '/plan/complete',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idPlanConfirmRoute = TTenant_idPlanConfirmRouteImport.update({
  id: '/plan/confirm',
  path: '/plan/confirm',
  getParentRoute: () => TTenant_idRouteRoute,
} as any)
const TTenant_idShearing_certificatesIndexRoute =
  TTenant_idShearing_certificatesIndexRouteImport.update({
    id: '/shearing_certificates/',
    path: '/shearing_certificates/',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)
const TTenant_idShearing_certificatesUploadRoute =
  TTenant_idShearing_certificatesUploadRouteImport.update({
    id: '/shearing_certificates/upload',
    path: '/shearing_certificates/upload',
    getParentRoute: () => TTenant_idRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/t/$tenant_id': typeof TTenant_idRouteRouteWithChildren
  '/admin/ocr_datasets': typeof AdminOcr_datasetsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/tenants/$id': typeof AdminTenantsIdRoute
  '/t/$tenant_id/ai_chat': typeof TTenant_idAi_chatRoute
  '/t/$tenant_id/setting': typeof TTenant_idSettingRoute
  '/t/$tenant_id/terms_of_use': typeof TTenant_idTerms_of_useRoute
  '/t/$tenant_id/upload': typeof TTenant_idUploadRoute
  '/t/$tenant_id/upload_history': typeof TTenant_idUpload_historyRoute
  '/t/$tenant_id/users': typeof TTenant_idUsersRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/t/$tenant_id/': typeof TTenant_idIndexRoute
  '/t/$tenant_id/millsheets/upload': typeof TTenant_idMillsheetsUploadRoute
  '/t/$tenant_id/order_matching/$steel_order_id': typeof TTenant_idOrder_matchingSteel_order_idRoute
  '/t/$tenant_id/plan/complete': typeof TTenant_idPlanCompleteRoute
  '/t/$tenant_id/plan/confirm': typeof TTenant_idPlanConfirmRoute
  '/t/$tenant_id/shearing_certificates/upload': typeof TTenant_idShearing_certificatesUploadRoute
  '/t/$tenant_id/order_matching/': typeof TTenant_idOrder_matchingIndexRoute
  '/t/$tenant_id/shearing_certificates/': typeof TTenant_idShearing_certificatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/admin/ocr_datasets': typeof AdminOcr_datasetsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin': typeof AdminIndexRoute
  '/admin/tenants/$id': typeof AdminTenantsIdRoute
  '/t/$tenant_id/ai_chat': typeof TTenant_idAi_chatRoute
  '/t/$tenant_id/setting': typeof TTenant_idSettingRoute
  '/t/$tenant_id/terms_of_use': typeof TTenant_idTerms_of_useRoute
  '/t/$tenant_id/upload': typeof TTenant_idUploadRoute
  '/t/$tenant_id/upload_history': typeof TTenant_idUpload_historyRoute
  '/t/$tenant_id/users': typeof TTenant_idUsersRoute
  '/admin/tenants': typeof AdminTenantsIndexRoute
  '/t/$tenant_id': typeof TTenant_idIndexRoute
  '/t/$tenant_id/millsheets/upload': typeof TTenant_idMillsheetsUploadRoute
  '/t/$tenant_id/order_matching/$steel_order_id': typeof TTenant_idOrder_matchingSteel_order_idRoute
  '/t/$tenant_id/plan/complete': typeof TTenant_idPlanCompleteRoute
  '/t/$tenant_id/plan/confirm': typeof TTenant_idPlanConfirmRoute
  '/t/$tenant_id/shearing_certificates/upload': typeof TTenant_idShearing_certificatesUploadRoute
  '/t/$tenant_id/order_matching': typeof TTenant_idOrder_matchingIndexRoute
  '/t/$tenant_id/shearing_certificates': typeof TTenant_idShearing_certificatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/sign_in': typeof Sign_inRoute
  '/sign_out': typeof Sign_outRoute
  '/t/$tenant_id': typeof TTenant_idRouteRouteWithChildren
  '/admin/ocr_datasets': typeof AdminOcr_datasetsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/tenants/$id': typeof AdminTenantsIdRoute
  '/t/$tenant_id/ai_chat': typeof TTenant_idAi_chatRoute
  '/t/$tenant_id/setting': typeof TTenant_idSettingRoute
  '/t/$tenant_id/terms_of_use': typeof TTenant_idTerms_of_useRoute
  '/t/$tenant_id/upload': typeof TTenant_idUploadRoute
  '/t/$tenant_id/upload_history': typeof TTenant_idUpload_historyRoute
  '/t/$tenant_id/users': typeof TTenant_idUsersRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/t/$tenant_id/': typeof TTenant_idIndexRoute
  '/t/$tenant_id/millsheets/upload': typeof TTenant_idMillsheetsUploadRoute
  '/t/$tenant_id/order_matching/$steel_order_id': typeof TTenant_idOrder_matchingSteel_order_idRoute
  '/t/$tenant_id/plan/complete': typeof TTenant_idPlanCompleteRoute
  '/t/$tenant_id/plan/confirm': typeof TTenant_idPlanConfirmRoute
  '/t/$tenant_id/shearing_certificates/upload': typeof TTenant_idShearing_certificatesUploadRoute
  '/t/$tenant_id/order_matching/': typeof TTenant_idOrder_matchingIndexRoute
  '/t/$tenant_id/shearing_certificates/': typeof TTenant_idShearing_certificatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/sign_in'
    | '/sign_out'
    | '/t/$tenant_id'
    | '/admin/ocr_datasets'
    | '/admin/plans'
    | '/admin/'
    | '/admin/tenants/$id'
    | '/t/$tenant_id/ai_chat'
    | '/t/$tenant_id/setting'
    | '/t/$tenant_id/terms_of_use'
    | '/t/$tenant_id/upload'
    | '/t/$tenant_id/upload_history'
    | '/t/$tenant_id/users'
    | '/admin/tenants/'
    | '/t/$tenant_id/'
    | '/t/$tenant_id/millsheets/upload'
    | '/t/$tenant_id/order_matching/$steel_order_id'
    | '/t/$tenant_id/plan/complete'
    | '/t/$tenant_id/plan/confirm'
    | '/t/$tenant_id/shearing_certificates/upload'
    | '/t/$tenant_id/order_matching/'
    | '/t/$tenant_id/shearing_certificates/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign_in'
    | '/sign_out'
    | '/admin/ocr_datasets'
    | '/admin/plans'
    | '/admin'
    | '/admin/tenants/$id'
    | '/t/$tenant_id/ai_chat'
    | '/t/$tenant_id/setting'
    | '/t/$tenant_id/terms_of_use'
    | '/t/$tenant_id/upload'
    | '/t/$tenant_id/upload_history'
    | '/t/$tenant_id/users'
    | '/admin/tenants'
    | '/t/$tenant_id'
    | '/t/$tenant_id/millsheets/upload'
    | '/t/$tenant_id/order_matching/$steel_order_id'
    | '/t/$tenant_id/plan/complete'
    | '/t/$tenant_id/plan/confirm'
    | '/t/$tenant_id/shearing_certificates/upload'
    | '/t/$tenant_id/order_matching'
    | '/t/$tenant_id/shearing_certificates'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/sign_in'
    | '/sign_out'
    | '/t/$tenant_id'
    | '/admin/ocr_datasets'
    | '/admin/plans'
    | '/admin/'
    | '/admin/tenants/$id'
    | '/t/$tenant_id/ai_chat'
    | '/t/$tenant_id/setting'
    | '/t/$tenant_id/terms_of_use'
    | '/t/$tenant_id/upload'
    | '/t/$tenant_id/upload_history'
    | '/t/$tenant_id/users'
    | '/admin/tenants/'
    | '/t/$tenant_id/'
    | '/t/$tenant_id/millsheets/upload'
    | '/t/$tenant_id/order_matching/$steel_order_id'
    | '/t/$tenant_id/plan/complete'
    | '/t/$tenant_id/plan/confirm'
    | '/t/$tenant_id/shearing_certificates/upload'
    | '/t/$tenant_id/order_matching/'
    | '/t/$tenant_id/shearing_certificates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  Sign_inRoute: typeof Sign_inRoute
  Sign_outRoute: typeof Sign_outRoute
  TTenant_idRouteRoute: typeof TTenant_idRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_in': {
      id: '/sign_in'
      path: '/sign_in'
      fullPath: '/sign_in'
      preLoaderRoute: typeof Sign_inRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_out': {
      id: '/sign_out'
      path: '/sign_out'
      fullPath: '/sign_out'
      preLoaderRoute: typeof Sign_outRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ocr_datasets': {
      id: '/admin/ocr_datasets'
      path: '/ocr_datasets'
      fullPath: '/admin/ocr_datasets'
      preLoaderRoute: typeof AdminOcr_datasetsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/t/$tenant_id': {
      id: '/t/$tenant_id'
      path: '/t/$tenant_id'
      fullPath: '/t/$tenant_id'
      preLoaderRoute: typeof TTenant_idRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants/': {
      id: '/admin/tenants/'
      path: '/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AdminTenantsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tenants/$id': {
      id: '/admin/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/admin/tenants/$id'
      preLoaderRoute: typeof AdminTenantsIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/t/$tenant_id/': {
      id: '/t/$tenant_id/'
      path: '/'
      fullPath: '/t/$tenant_id/'
      preLoaderRoute: typeof TTenant_idIndexRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/ai_chat': {
      id: '/t/$tenant_id/ai_chat'
      path: '/ai_chat'
      fullPath: '/t/$tenant_id/ai_chat'
      preLoaderRoute: typeof TTenant_idAi_chatRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/setting': {
      id: '/t/$tenant_id/setting'
      path: '/setting'
      fullPath: '/t/$tenant_id/setting'
      preLoaderRoute: typeof TTenant_idSettingRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/terms_of_use': {
      id: '/t/$tenant_id/terms_of_use'
      path: '/terms_of_use'
      fullPath: '/t/$tenant_id/terms_of_use'
      preLoaderRoute: typeof TTenant_idTerms_of_useRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/upload': {
      id: '/t/$tenant_id/upload'
      path: '/upload'
      fullPath: '/t/$tenant_id/upload'
      preLoaderRoute: typeof TTenant_idUploadRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/upload_history': {
      id: '/t/$tenant_id/upload_history'
      path: '/upload_history'
      fullPath: '/t/$tenant_id/upload_history'
      preLoaderRoute: typeof TTenant_idUpload_historyRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/users': {
      id: '/t/$tenant_id/users'
      path: '/users'
      fullPath: '/t/$tenant_id/users'
      preLoaderRoute: typeof TTenant_idUsersRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/millsheets/upload': {
      id: '/t/$tenant_id/millsheets/upload'
      path: '/millsheets/upload'
      fullPath: '/t/$tenant_id/millsheets/upload'
      preLoaderRoute: typeof TTenant_idMillsheetsUploadRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/order_matching/': {
      id: '/t/$tenant_id/order_matching/'
      path: '/order_matching'
      fullPath: '/t/$tenant_id/order_matching/'
      preLoaderRoute: typeof TTenant_idOrder_matchingIndexRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/order_matching/$steel_order_id': {
      id: '/t/$tenant_id/order_matching/$steel_order_id'
      path: '/order_matching/$steel_order_id'
      fullPath: '/t/$tenant_id/order_matching/$steel_order_id'
      preLoaderRoute: typeof TTenant_idOrder_matchingSteel_order_idRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/plan/complete': {
      id: '/t/$tenant_id/plan/complete'
      path: '/plan/complete'
      fullPath: '/t/$tenant_id/plan/complete'
      preLoaderRoute: typeof TTenant_idPlanCompleteRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/plan/confirm': {
      id: '/t/$tenant_id/plan/confirm'
      path: '/plan/confirm'
      fullPath: '/t/$tenant_id/plan/confirm'
      preLoaderRoute: typeof TTenant_idPlanConfirmRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/shearing_certificates/': {
      id: '/t/$tenant_id/shearing_certificates/'
      path: '/shearing_certificates'
      fullPath: '/t/$tenant_id/shearing_certificates/'
      preLoaderRoute: typeof TTenant_idShearing_certificatesIndexRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
    '/t/$tenant_id/shearing_certificates/upload': {
      id: '/t/$tenant_id/shearing_certificates/upload'
      path: '/shearing_certificates/upload'
      fullPath: '/t/$tenant_id/shearing_certificates/upload'
      preLoaderRoute: typeof TTenant_idShearing_certificatesUploadRouteImport
      parentRoute: typeof TTenant_idRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminOcr_datasetsRoute: typeof AdminOcr_datasetsRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminTenantsIdRoute: typeof AdminTenantsIdRoute
  AdminTenantsIndexRoute: typeof AdminTenantsIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminOcr_datasetsRoute: AdminOcr_datasetsRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminTenantsIdRoute: AdminTenantsIdRoute,
  AdminTenantsIndexRoute: AdminTenantsIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface TTenant_idRouteRouteChildren {
  TTenant_idAi_chatRoute: typeof TTenant_idAi_chatRoute
  TTenant_idSettingRoute: typeof TTenant_idSettingRoute
  TTenant_idTerms_of_useRoute: typeof TTenant_idTerms_of_useRoute
  TTenant_idUploadRoute: typeof TTenant_idUploadRoute
  TTenant_idUpload_historyRoute: typeof TTenant_idUpload_historyRoute
  TTenant_idUsersRoute: typeof TTenant_idUsersRoute
  TTenant_idIndexRoute: typeof TTenant_idIndexRoute
  TTenant_idMillsheetsUploadRoute: typeof TTenant_idMillsheetsUploadRoute
  TTenant_idOrder_matchingSteel_order_idRoute: typeof TTenant_idOrder_matchingSteel_order_idRoute
  TTenant_idPlanCompleteRoute: typeof TTenant_idPlanCompleteRoute
  TTenant_idPlanConfirmRoute: typeof TTenant_idPlanConfirmRoute
  TTenant_idShearing_certificatesUploadRoute: typeof TTenant_idShearing_certificatesUploadRoute
  TTenant_idOrder_matchingIndexRoute: typeof TTenant_idOrder_matchingIndexRoute
  TTenant_idShearing_certificatesIndexRoute: typeof TTenant_idShearing_certificatesIndexRoute
}

const TTenant_idRouteRouteChildren: TTenant_idRouteRouteChildren = {
  TTenant_idAi_chatRoute: TTenant_idAi_chatRoute,
  TTenant_idSettingRoute: TTenant_idSettingRoute,
  TTenant_idTerms_of_useRoute: TTenant_idTerms_of_useRoute,
  TTenant_idUploadRoute: TTenant_idUploadRoute,
  TTenant_idUpload_historyRoute: TTenant_idUpload_historyRoute,
  TTenant_idUsersRoute: TTenant_idUsersRoute,
  TTenant_idIndexRoute: TTenant_idIndexRoute,
  TTenant_idMillsheetsUploadRoute: TTenant_idMillsheetsUploadRoute,
  TTenant_idOrder_matchingSteel_order_idRoute:
    TTenant_idOrder_matchingSteel_order_idRoute,
  TTenant_idPlanCompleteRoute: TTenant_idPlanCompleteRoute,
  TTenant_idPlanConfirmRoute: TTenant_idPlanConfirmRoute,
  TTenant_idShearing_certificatesUploadRoute:
    TTenant_idShearing_certificatesUploadRoute,
  TTenant_idOrder_matchingIndexRoute: TTenant_idOrder_matchingIndexRoute,
  TTenant_idShearing_certificatesIndexRoute:
    TTenant_idShearing_certificatesIndexRoute,
}

const TTenant_idRouteRouteWithChildren = TTenant_idRouteRoute._addFileChildren(
  TTenant_idRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  Sign_inRoute: Sign_inRoute,
  Sign_outRoute: Sign_outRoute,
  TTenant_idRouteRoute: TTenant_idRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
